/*
  By: Manohar
  On: 23/10/2026
  Modification: Delete Case modal (only for support@waybeyond.tech) to remove interactions along with their tasks
*/
import { h } from 'preact';
import { useState } from 'preact/hooks';
import axios from 'axios';
import toastr from 'toastr';
import CONSTANTS from '../../lib/constants';

const DeleteCaseModal = (props) => {
  const { onClose } = props;

  const [interactionIDs, setInteractionIDs] = useState(['']);
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteResult, setDeleteResult] = useState(null);

  const closeModal = (e) => {
    if (isDeleting) return;
    onClose && onClose(e);
  };

  const updateInteractionID = (index, value) => {
    let updatedInteractionIDs = [...interactionIDs];
    updatedInteractionIDs[index] = value;
    setInteractionIDs(updatedInteractionIDs);
  };

  const addInteractionID = () => {
    setInteractionIDs([...interactionIDs, '']);
  };

  const removeInteractionID = (index) => {
    let updatedInteractionIDs = interactionIDs.filter((interactionID, i) => i !== index);
    setInteractionIDs(updatedInteractionIDs.length ? updatedInteractionIDs : ['']);
  };

  const confirmDelete = async () => {
    const uniqueInteractionIDs = [...new Set(interactionIDs.map(interactionID => interactionID.trim()).filter(Boolean))];
    if (!uniqueInteractionIDs.length) {
      toastr.warning('Please enter at least one interaction UUID');
      return;
    }
    if (!window.confirm(`Permanently delete ${uniqueInteractionIDs.length} case(s) and all their tasks? This cannot be undone.`)) {
      return;
    }
    try {
      setIsDeleting(true);
      let response = await axios.post(`${CONSTANTS.API_URL}/api/v1/interaction/removeWithTasks`, { interactionIDs: uniqueInteractionIDs });
      setDeleteResult(response.data);
      setInteractionIDs(['']);
      toastr.success(`${response.data.removedCount} of ${uniqueInteractionIDs.length} case(s) deleted`);
    } catch (HTTPException) {
      console.error(HTTPException);
      toastr.error(HTTPException.response && HTTPException.response.data && HTTPException.response.data.message ? HTTPException.response.data.message : 'Failed to delete cases');
    }
    setIsDeleting(false);
  };

  return (
    <div class='orgChartModal'>
      <div style="display:block;" class="org-chart-modal">
        <div class="card org-chart-modal-content org-chart-width p-b-0 p-t-0 p-r-0 p-l-0">
          <div class="pos-relative">
            <div class="modal-header">
              <span class='fs-12'>
                <ul class='breadrcrumb_arrows_inverted m-r-8'>
                  <li>Delete Case</li>
                </ul>
              </span>
              <span class="modal-close" onClick={(e) => closeModal(e)}>&times;</span>
            </div>
            <div class="org-chart-modal-body background-transparent p-l-15 p-r-15" style="max-height:50vh; overflow:auto">
              <p class="fs-12 text-error m-b-10">Cases and all their tasks will be permanently deleted.</p>
              {
                interactionIDs.map((interactionID, index) => (
                  <div class="display-flex align-center m-b-10">
                    <input
                      type="text"
                      placeholder="Interaction UUID"
                      value={interactionID}
                      onInput={(e) => updateInteractionID(index, e.target.value)}
                      disabled={isDeleting}
                    />
                    <button class="secondary-button m-l-10" onClick={() => removeInteractionID(index)} disabled={isDeleting || (interactionIDs.length === 1 && !interactionID)} title="Remove">&times;</button>
                  </div>
                ))
              }
              <button class="secondary-button" onClick={addInteractionID} disabled={isDeleting}>+ Add Interaction UUID</button>
              {
                deleteResult && deleteResult.result && (
                  <div class="m-t-15">
                    <p class="f-w-600 m-b-5">{deleteResult.removedCount} case(s) deleted</p>
                    <table class="w-full fs-12">
                      <thead>
                        <tr>
                          <th class="text-left">Interaction UUID</th>
                          <th class="text-left">Status</th>
                          <th class="text-left">Removed Tasks</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          deleteResult.result.map((item) => (
                            <tr>
                              <td>{item.interactionID}</td>
                              <td class={item.status === 'removed' ? 'text-green' : 'text-error'}>
                                {item.status === 'removed' ? 'Removed' : item.status === 'notFound' ? 'Not found' : `Failed${item.errorMessage ? ' - ' + item.errorMessage : ''}`}
                              </td>
                              <td>{item.removedTaskCount}</td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                  </div>
                )
              }
            </div>
            <div class="display-flex justify-flex-end p-10" style="border-top:1px solid lightgrey">
              <button class="secondary-button m-r-10" onClick={(e) => closeModal(e)} disabled={isDeleting}>Close</button>
              <button class="primary-button" style="background:#d32f2f; border-color:#d32f2f" onClick={confirmDelete} disabled={isDeleting || !interactionIDs.some(interactionID => interactionID.trim())}>
                {isDeleting ? 'Deleting...' : 'Confirm Delete'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteCaseModal;
